import { Amplify } from "aws-amplify";

export const configureAwsAppSync = async ({ aws_appsync_graphqlEndpoint }) => {
  try {
    const myAppConfig = {
      aws_appsync_graphqlEndpoint
    };
    Amplify.configure(myAppConfig);
  } catch (error) {
    console.log("error signing out: ", error);
  }
};
